import React, {useEffect, useRef, useState, useCallback} from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import EscolaService from "../../../../../services/EscolaService";
import Table from "@material-ui/core/Table";
import {useStyles} from '@base/Table/Style';
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import DescartarCartaoDialog from "@pages/TratamentoNomes/DescartarCartaoDialog"
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutline";
import RestoreFromTrashIcon from "@material-ui/icons/RestoreFromTrash";
import DialogConfirm from "../../../../base/Dialog/DialogConfirm";
import Tooltip from "@material-ui/core/Tooltip";
import Zoom from "@material-ui/core/Zoom";
import IconButton from "@material-ui/core/IconButton";
import Loading from "../../../../base/Loading";
import CardIcon from "@material-ui/icons/LibraryBooks";
import Dialog from '@base/Dialog'
import VisualizadorDeArquivo from '@base/VisualizadorDeArquivo';

const CollapsibleTable = ({style, processo, object, children}) => {
  const classes = useStyles();

  const [cartoes, setCartoes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [horaUltimoRefresh, setHoraUltimoRefresh] = useState();
  const [cartaoSelecionado, setCartaoSelecionado] = useState("");
  const [openDialogRestaurarCartao, setOpenDialogRestaurarCartao] = useState(false);
  const [openDialogDescartarCartao, setOpenDialogDescartarCartao] = useState(false);
  const [blob, setBlob] = useState();
  const [openModalVisualizarArquivo, setOpenModalVisualizarArquivo] = useState(false);
  const [ilegivel, setIlegivel] = useState(false);


  const toastRef = useRef(null);

  const columns = [
    {label: 'id', name: 'id', key: true, hidden: true,},
    {
      label: 'Origem do Cartão',
      name: 'origem',
      func: (objColuna, objLinha) => objColuna ? objColuna.descricao : "",
      key: false
    },
    {label: 'Código', name: 'codigo', key: false},
    {label: 'Nome', name: 'nomeAluno', key: false},

  ]
  const buscarCartoesClonados = useCallback(() => {
    if (processo !== undefined) {
      setLoading(true);
      const filters = [];
      filters.push({field: 'nome', value: object.nomeAluno});
      filters.push({field: 'inep', value: object.original.codigoInep});
      EscolaService.buscarCartoes(processo, filters).then((resultado) => {
        setCartoes(resultado.data.content);
        setLoading(false);
      }).catch(erro => {
        toastRef.current.show("error", "Não foi possível buscar cartões duplicados.");
      });
      ;
    }
  },[processo, object]);

  const restaurarCartao = (cartao, setLoading) => {
    EscolaService.restaurarCartao(processo, cartao.id).then(() => {
      setOpenDialogRestaurarCartao(false);
      setLoading(false);
      setHoraUltimoRefresh(new Date())

    });
  }

  useEffect(() => {
    buscarCartoesClonados();
  }, [horaUltimoRefresh, buscarCartoesClonados]);

  const actionCollapsible = {
    name: (c, l) => l.status && l.status === "DESCARTADO" && !l.substituido ? "Restaurar Cartão" : "Descartar Cartão",
    func: (id, teste) => {
      let c = cartoes.find(c => c.id === id);
      if (c.status && c.status === "DESCARTADO") {
        setCartaoSelecionado(cartoes.find(c => c.id === id));
        setOpenDialogRestaurarCartao(true);
      } else {
        setCartaoSelecionado(cartoes.find(c => c.id === id));
        setOpenDialogDescartarCartao(true);
      }
    },
    icon: (col, l) => {
      if (l.status && l.status === "DESCARTADO" && !l.substituido) {
        return <RestoreFromTrashIcon/>;
      } else {
        return <DeleteOutlinedIcon/>;
      }
    },
    color: (c, l) => l.status && l.status === "DESCARTADO" ? "primary" : "secondary",
    disabled: (id, cartao) => {
      return cartao.substituido;
    },
  };

  const actionVisualizarCartao = {
    func: (id) => visualizarArquivo(id),
    icon: <CardIcon/>,
    disabled: (id) => {
      const cartao = cartoes.find(c => c.id === id);
      return (cartao.nomeArquivo === "") || (cartao.nomeArquivo === null) || (cartao.nomeArquivo === undefined);
    },
    name: (id) => {
      const cartao = cartoes.find(c => c.id === id);
      return (cartao.nomeArquivo === "") || (cartao.nomeArquivo === null) || (cartao.nomeArquivo === undefined) ? "Não existe arquivo digitalizado." : "Visualizar Digitalização";
    },
    collapse: true
  };

  const visualizarArquivo = (id) => {
    const cartao = cartoes.find(c => c.id === id);
    if (cartao.nomeArquivo) {
      EscolaService.downloadArquivoCartao(processo, undefined, cartao.id).then(resultado => {
        setBlob(resultado.data);
        setCartaoSelecionado(cartao);
        setOpenModalVisualizarArquivo(true);
      }).catch(erro => {
        toastRef.current.show("error", "Não foi posível fazer download do arquivo.");
      });
    } else {
      alert("Arquivo inexistente");
    }
  }

  const ActionCellBody = ({action, id, object}) => {
    if (!action.func) {
      return null
    }

    return (
      <TableCell align="right">
        <Tooltip title={action.name(id, object)} TransitionComponent={Zoom}>
        <span style={action.disabled(id, object) ? {cursor: 'not-allowed'} : {}}>
          <IconButton
            size="small"
            component="div"
            color={action.color ? (typeof action.color === "function" ? action.color(id, object) : action.color) : "primary"}
            aria-label={action.name(id, object)}
            onClick={() => action.func(id, object)}
            disabled={action.disabled(id, object)}
            style={action.disabled(id, object) ? {pointerEvents: "none"} : {}}
          >
            {typeof action.icon === "function" ? action.icon(id, object) : action.icon}
          </IconButton>
        </span>
        </Tooltip>
      </TableCell>
    )
  }
  return (
    <>
      <Table className={classes.spacingTable}
             style={{borderLeft: '1px solid #e0e0e0', borderRight: '1px solid #e0e0e0'}}>
        <TableHead>
          <TableRow>
            {columns.map((column, index) => (
              column.name !== "id" &&
              <th key={index}>{column.label}</th>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {loading ?
            <TableRow align={"center"}>
              <TableCell align="center" rowSpan={2}>
                <Loading/>
              </TableCell>
            </TableRow> :
            cartoes.length === 1 ?
              <TableRow style={{height: 53}} align={"center"}>
                <TableCell colSpan={columns.length} align="center">
                  Não Foram Encontrados Registros para Exibição
                </TableCell>
              </TableRow> :
              cartoes.map((cartao, index) => (
                cartao.id === object.id ? <></> :
                  <TableRow key={index} hover>
                    {columns.map((column, colIndex) => (
                      column.name !== "id" &&
                      <TableCell key={colIndex} style={{color: cartao.status === "DESCARTADO" ? "#bbb" : null}}
                                 align={"center"}>
                        {column.func ? column.func(cartao[column.name], cartao) : cartao[column.name]}
                      </TableCell>
                    ))}
                    {cartao.codigo === object.codigo ?
                      <TableCell width={50} colSpan={2}>
                      Este cartão deve ser tratado na tela de tratamento de duplicados
                    </TableCell>  :
                      <>
                        <ActionCellBody id={cartao.id} action={actionVisualizarCartao} object={cartao}/>
                        <ActionCellBody id={cartao.id} action={actionCollapsible} object={cartao}/>
                      </>
                    }

                  </TableRow>
              ))}
        </TableBody>
      </Table>
      {openDialogDescartarCartao &&
        <DescartarCartaoDialog
          mensagemCustomizada={"Ao descartar o cartão a pendência de nome será automaticamente atualizada para 'Resolvida'"}
          aoConfirmar={() => setHoraUltimoRefresh(new Date())}
          aoFechar={() => setOpenDialogDescartarCartao(false)}
          aberto={openDialogDescartarCartao}
          processo={processo}
          motivosDescarteDisponiveis={() => {
            return [{value: 'TRATAMENTO_NOME', label: 'Tratamento de Nome'}]
          }}
          id={cartaoSelecionado.id}
          codigo={cartaoSelecionado.codigo}/>}
      {openDialogRestaurarCartao &&
        <DialogConfirm
          maxWidth={"sm"}
          id={{id: cartaoSelecionado.id}}
          text={"Deseja realmente restaurar este cartão?"}
          close={() => setOpenDialogRestaurarCartao(false)}
          open={openDialogRestaurarCartao}
          title={"Importante"}
          handleConfirm={restaurarCartao}
        />
      }
      {openModalVisualizarArquivo &&
        <Dialog
          maxWidth={"lg"}
          fullWidth={true}
          closeDialog={() => setOpenModalVisualizarArquivo(false)}
          openDialog={openModalVisualizarArquivo}
          title={`Cartão ${cartaoSelecionado.codigo}`}
          actions={[]}
        >
          <VisualizadorDeArquivo
            ilegivel={ilegivel}
            aoMarcarComoIlegivel={() => {
              EscolaService.cartaoIlegivel(processo, cartaoSelecionado.escola, cartaoSelecionado.id).then(resultado => {
                setIlegivel(true);
              });
            }}
            blob={blob}
          />
        </Dialog>
      }
    </>
  );
};


export default CollapsibleTable;
